import axiosInstance from "./AxiosInstance";


export function getSettingUsers() {
  return axiosInstance.post("/setting/settingList", { });
}


export function updateSettingUser(setting_update) {
    return axiosInstance.post("/setting/editSetting", {
      setting_update: JSON.stringify(setting_update.setting_update)
    });
  }
